import { useNewDesign } from '../../../../state/DesignPreferenceContextProvider';
import SearchResultsTopbarNewUI, {
  SearchResultsTopbarNewUIProps,
} from './SearchResultsTopbarNewUI';
import SearchResultsTopbarOldUI, {
  SearchResultsTopbarOldUIProps,
} from './SearchResultsTopbarOldUI';
import React from 'react';

type SearchResultsTopbarProps = SearchResultsTopbarOldUIProps &
  SearchResultsTopbarNewUIProps & { forceNewDesign?: boolean };

const SearchResultsTopbar: React.FC<SearchResultsTopbarProps> = (props) => {
  const { prefersNewDesign } = useNewDesign();
  const SearchResultsTopbarComponent = props.forceNewDesign || prefersNewDesign
    ? SearchResultsTopbarNewUI
    : SearchResultsTopbarOldUI;

  return <SearchResultsTopbarComponent {...props} />;
};

export default SearchResultsTopbar;
